import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Api } from "../lib/api";
import { RouteComponentProps } from "@reach/router";
import { Layout } from "./Layout";
import { CountsContext } from "../lib/counts";

const mapKeyToLabel = (key: string) => {
  switch (key) {
    case "allNew":
      return "New users";
    case "newSignup":
      return "Started Signup";
    case "completedSignup":
      return "Finished Signup";
    case "fullCrawlRunning":
      return "In Progress";
    case "importFinished":
      return "Import Finished";
    case "allActive":
      return "Active";
    case "active":
      return "Cont. Crawl";
    case "activeNewWebsite":
      return "Added Website";
    case "activeAwaitingFeedback":
      return "Awaiting Feedback";
    case "activeFullCrawlRunning":
      return "In Progress";
    case "activeImportFinished":
      return "Act Import Finished";
    case "inactive":
      return "Inactive";
    default:
      return key;
  }
};

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export const UserCountsView = (props: RouteComponentProps) => {
  const classes = useStyles();
  const { counts, setCounts } = useContext(CountsContext);

  React.useEffect(() => {
    if (counts) return;

    const fetchData = async () => {
      const counts = await Api.getCounts();
      setCounts(counts.data);
    };

    fetchData();
  }, []);

  const keys = Object.keys(counts || {});

  return (
    <Layout title={`UserCounts`}>
      <Table
        className={classes.table}
        size="small"
        aria-label="a dense table"
        style={{ width: 300 }}
      >
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }} align="left">
              State
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="right">
              Count
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {counts &&
            keys.map((key) => {
              if (key === "allSemiActive") return <></>;

              return (
                <TableRow>
                  <TableCell align="left">{mapKeyToLabel(key)}</TableCell>
                  <TableCell align="right">
                    {
                      //@ts-ignore
                      counts[key]
                    }
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </Layout>
  );
};
